import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { FooterSupport } from '@pro/common/FooterSupport';
import HelpLocation from '@base/common/HelpLocation';
import { helpConfig } from 'pro/config/help';
import { useHelpGroups } from 'mod/help/useHelpGroups';
import { TiledHelpGroups } from 'mod/help/TiledHelpGroups';
import { SiteSNS } from '@base/common/SiteSNS';
import { Subscribe } from '@pro/common/Subscribe';
import { Copyright } from '@base/common/Copyright';
import site from 'pro/config/site';
import { useTrans } from 'base/utils/i18n';

export type IPageFooterProps = {
    className?: string;
    spaceTop?: boolean;
};

const PageFooter: React.FC<IPageFooterProps> = props => {
    const { className, spaceTop = false } = props;
    const helpGroups = useHelpGroups(helpConfig);
    const { t } = useTrans();

    return (
        <div className={cn(className, styles.footer, { [styles['space-top']]: spaceTop })}>
            <div className="wrapper">
                <FooterSupport className={styles.support}/>

                <div className={cn(styles['footer-links'], 'flex')}>
                    <div className={styles.col1}>
                        <TiledHelpGroups className={styles.help} groups={helpGroups}/>
                    </div>
                    <div className={styles.col2}>
                        <HelpLocation className={styles.location}/>
                        <SiteSNS className={styles.sns}/>
                    </div>
                </div>
                <Subscribe
                    className={styles.subscribe}
                    moduleId="subscribe-common-footer"
                    title={t('web_subscribe_title', { discount: site.registerActivity.discount })}
                />
                <Copyright className={styles.copyright}/>
            </div>
        </div>
    )
};

export default PageFooter;
